const users = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@gmail.com',
    role: 'Admin',
    avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/women/2.jpg',
  },
  {
    id: 3,
    name: 'Alice Johnson',
    email: 'alice.johnson@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/women/3.jpg',
  },
  {
    id: 4,
    name: 'Sara Ahmed',
    email: 'sara.ahmed@gmail.com',
    role: 'Content Creator',
    avatar: 'https://randomuser.me/api/portraits/women/4.jpg',
  },
  {
    id: 5,
    name: 'Victoria Miles',
    email: 'victoria.miles@gmail.com',
    role: 'Content Creator',
    avatar: 'https://randomuser.me/api/portraits/women/5.jpg',
  },
  {
    id: 6,
    name: 'Alex Johnson',
    email: 'alex.johnson@gmail.com',
    role: 'Content Creator',
    avatar: 'https://randomuser.me/api/portraits/men/6.jpg',
  },
  {
    id: 7,
    name: 'Mona Hassan',
    email: 'mona.hassan@gmail.com',
    role: 'Content Creator',
    avatar: 'https://randomuser.me/api/portraits/women/7.jpg',
  },
  {
    id: 8,
    name: 'Lara Nabil',
    email: 'lara.nabil@gmail.com',
    role: 'Content Creator',
    avatar: 'https://randomuser.me/api/portraits/women/8.jpg',
  },
  {
    id: 9,
    name: 'Amira Khaled',
    email: 'amira.khaled@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/women/9.jpg',
  },
  {
    id: 10,
    name: 'Shimaa Adel',
    email: 'shimaa.adel@gmail.com',
    role: 'Content Creator',
    avatar: 'https://randomuser.me/api/portraits/women/10.jpg',
  },
  {
    id: 11,
    name: 'Fathy Mostafa',
    email: 'fathy.mostafa@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/men/11.jpg',
  },
  {
    id: 12,
    name: 'Ashraf Kamal',
    email: 'ashraf.kamal@gmail.com',
    role: 'Admin',
    avatar: 'https://randomuser.me/api/portraits/men/12.jpg',
  },
  {
    id: 13,
    name: 'Menna Samir',
    email: 'menna.samir@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/women/13.jpg',
  },
  {
    id: 14,
    name: 'Menna Samir',
    email: 'menna.samir@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/women/13.jpg',
  },
  {
    id: 15,
    name: 'Menna Samir',
    email: 'menna.samir@gmail.com',
    role: 'User',
    avatar: 'https://randomuser.me/api/portraits/women/13.jpg',
  },
];

export default users;
